import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-custom-button-renderer',
  template: `
    <div >
        <button type="button" class="btn custome" id="button" (click)="onClick()" data-toggle="tooltip"
            data-placement="bottom" style="font-size: 11px; padding: 2px 3px">
            {{params.label}}   
        </button>
    </div>
    `
})

export class CustomButtonRendererComponent implements ICellRendererAngularComp {

    params;
    label: string;

    agInit(params): void {
        this.params = params;
        this.label = this.params.label || null;
    }

    refresh(params?: any): boolean {
        return true;
    }

    onClick($event) {
        if (this.params.onClick instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            }
            this.params.onClick(params);
        }
    }
}